import {
    useEffect,
    VoidFunctionComponent
} from "react";
import { CommercialOperations } from "@/models/scope/productSheet/CommercialOperations";
import { setTimerForFlashSale } from "@/utils/responsive/SetTimerForFlashSalePicto";
import Utils from "@/libs/Utils";

interface Props {
    commercialOperations: CommercialOperations[],
    eligibilityToPrivateSale: boolean,
    soldBy: string,
    eligibleSoldBy: string[];

}

export const FlashSalePicto: VoidFunctionComponent<Props> = ({
    commercialOperations,
    eligibilityToPrivateSale,
    soldBy,
    eligibleSoldBy
}) => {
    useEffect(() => {
        setTimerForFlashSale()
    }, [])

    let commercialOperationList = commercialOperations ? Utils.prepareCommercialOperationListByType(commercialOperations) : null;
    let commercialOperationFlashSale = commercialOperationList?.pictoFlashSaleList[0];
    if (commercialOperationFlashSale && ((soldBy == 'BUT') || (soldBy == 'BUT_MKP' && eligibleSoldBy.indexOf(commercialOperationFlashSale.soldBy) >= 0)|| (soldBy !== 'BUT_MKP' && (soldBy == commercialOperationFlashSale.soldBy)))) {
        if ((!commercialOperationFlashSale.isPrivate) || (eligibilityToPrivateSale && commercialOperationFlashSale.isPrivate)) {
            let commercialOperationBackgrounColor = Utils.getMetaInfosValueByCode("pictoColorFond", commercialOperationFlashSale.metaInfos);
            let commercialOperationTextColor = Utils.getMetaInfosValueByCode("pictoColorText", commercialOperationFlashSale.metaInfos);
            let titleStyle = {
                color: commercialOperationTextColor,
                backgroundColor: commercialOperationBackgrounColor
            };
            let decompterStyle = {
                color: commercialOperationBackgrounColor,
                backgroundColor: commercialOperationTextColor
            }
            let borderStyle = {
                border: '1px solid' + commercialOperationBackgrounColor,
                backgroundColor: commercialOperationTextColor,
                padding: 0
            }
            let pictoEndDate = commercialOperationFlashSale.endDate;
            let commercialOperationLink = Utils.renderCommercialOperationLink(commercialOperationFlashSale);
            return (<a href={commercialOperationLink}
                className="sticker-com countdown" title={commercialOperationLink} style={{backgroundColor: commercialOperationBackgrounColor}}>
                <span className="title" style={titleStyle}>{commercialOperationLink}</span>
                <span className="timer" data-time={pictoEndDate} style={decompterStyle}
                    id={"clockdiv"}>
                    <span className="days" />
                    <span className="hours" />
                    <span className="minutes" />
                    <span className="seconds" />
                </span>
            </a>)
        }
        return null;
    }
    return null;
}
